import type { ReactNode } from 'react'
import { InfoCircleIcon } from '@/components/ui/icons'
import { Skeleton } from '@/components/ui/skeleton'
import { useTranslation } from '@/translations/i18n'

/** Page frame shared by the Export tab and its three standalone states. */
export function ExportPageShell({ children }: { children: ReactNode }) {
	const { t } = useTranslation()
	return (
		<div className='flex flex-col gap-6 l:px-10 px-4 pt-6 pb-10'>
			<title>{t('marquee:page_title_export')}</title>
			{children}
		</div>
	)
}

/** Shown when the event has not closed yet: export is not available. */
export function ExportUnavailable() {
	const { t } = useTranslation()
	return (
		<ExportPageShell>
			<div className='flex flex-col items-center gap-2 rounded-airbnb-2xl border border-grey-200 border-dashed px-6 py-16 text-center'>
				<InfoCircleIcon className='size-6 text-neutral-400' />
				<p className='font-medium text-neutral-900'>
					{t('marquee:export_header_title')}
				</p>
				<p className='max-w-md text-neutral-500 text-sm'>
					{t('marquee:checkin_close_dialog_description')}
				</p>
			</div>
		</ExportPageShell>
	)
}

export function ExportLoading() {
	return (
		<ExportPageShell>
			<div className='grid l:grid-cols-[1.6fr_1fr] gap-4'>
				<Skeleton height={320} />
				<Skeleton height={320} />
			</div>
			<Skeleton height={360} />
		</ExportPageShell>
	)
}

export function ExportError() {
	const { t } = useTranslation()
	return (
		<ExportPageShell>
			<div className='flex flex-col items-center gap-2 rounded-airbnb-2xl border border-red-200 bg-red-50 px-6 py-16 text-center'>
				<p className='font-medium text-neutral-900'>
					{t('marquee:error_title')}
				</p>
				<p className='text-neutral-500 text-sm'>
					{t('marquee:error_description')}
				</p>
			</div>
		</ExportPageShell>
	)
}
